// src/pages/Terminos.jsx
import React from "react";

const Terminos = () => {
  return (
    <div className="container py-4">
      <h1 className="fw-bold mb-3">Términos y Condiciones</h1>
      <p className="text-secondary">
        Al utilizar QRBenefits aceptás estos términos básicos de uso.
      </p>

      <h5 className="fw-bold mt-4">1. Uso de la plataforma</h5>
      <p>Los beneficios pueden tener condiciones específicas definidas por cada comercio.</p>

      <h5 className="fw-bold mt-4">2. Responsabilidad del comercio</h5>
      <p>QRBenefits no define los precios ni los beneficios, solo facilita su uso.</p>

      <h5 className="fw-bold mt-4">3. Cuenta del usuario</h5>
      <p>Mantené la información de tu cuenta segura y actualizada.</p>
    </div>
  );
};

export default Terminos;
